<template>
    <div class="form-manage-wrapper">
        <TagTrees @selectClick="selectHandle"></TagTrees>
        <div class="form-table scroll-tracker">
            <div class="content-top">
                <p class="title">
                    <span class="tit">{{ currentScene }}</span
                    > ({{ totalTip }}<em> {{ total }} </em>{{ totalFormTip }})
                </p>
                <FormOptBar
                    class="content-opeat"
                    @langSelect="langSelect"
                    @statusSelect="statusSelect"
                    @formTypeSelect="formTypeSelect"
                    @formSearch="formSearch"
                />
            </div>
            <Table :curPage="curPage" :config="tableConfig" :dataset="tableData" :total="total" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import TagTrees from "./components/TagTrees";
import FormOptBar from "./components/FormOptBar";
import Table from "@/views/zhiji/bComponents/table/Table";
import { recursionFind, getParentTree, throttle } from "@/views/zhiji/js/common/util.js";
import { formListTable } from "./formConfig.js";

export default {
    name: "FormManagePage",
    props: [],
    components: {
        TagTrees,
        FormOptBar,
        Table
    },
    data() {
        return {
            curPage: 1,
            curPageLen: formListTable().pageLength,
            lang: "",
            status: "",
            keyword: "",
            type: ""
        };
    },
    computed: {
        tableConfig() {
            return formListTable();
        },
        totalTip() {
            return this.$t("zhiji.common.total");
        },
        totalFormTip() {
            return this.$t("zhiji.form.totalFormTip");
        },
        tableData() {
            return this.getStorePorp("tableDatas");
        },
        total() {
            return this.getStorePorp("total");
        },
        currentScene() {
            let selectedSceneId = this.getStorePorp("querySetting").classId;
            return selectedSceneId ? this.findParentScene(selectedSceneId) : this.$t("zhiji.common.allClassify");
        }
    },
    watch: {
        totalTip() {
            this.queryFormList();
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.formManagePage[propName];
        },
        initCurrPage() {
            this.curPage = 1;
        },
        selectHandle() {
            this.initCurrPage();
        },
        getSceneNameById(sceneId) {
            const treeData = this.getStorePorp("treeData").children || [];

            let scene = recursionFind(
                treeData,
                nodeData => {
                    return nodeData.id == sceneId;
                },
                "children"
            );

            return scene ? scene.label : "";
        },
        findParentScene(sceneId) {
            let sceneLabel = this.getSceneNameById(sceneId);
            const treeData = this.getStorePorp("treeData").children || [];
            if (sceneLabel != "" && treeData.length > 0) {
                let parentTree = getParentTree(treeData, sceneLabel);
                let parents = parentTree.path.split("/");

                this.updateFormEditInfo(parents);

                parents = parents.map(parentId => {
                    return this.getSceneNameById(parentId);
                });

                return parents.join(" > ");
            }
        },
        updateFormEditInfo(data) {
            if (data.length > 1) {
                this.$store.commit("zhiji/updateFormInfo", {
                    tagId: data[data.length - 1]
                });
            } else {
                this.$store.commit("zhiji/updateFormInfo", {
                    tagId: ""
                });
            }
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.queryFormList();
        },
        langSelect(data) {
            this.lang = data.value;
            this.queryFormList();
        },
        statusSelect(data) {
            this.status = data.value;
            this.queryFormList();
        },
        formTypeSelect(data) {
            this.type = data.value;
            this.queryFormList();
        },
        formSearch(data) {
            this.keyword = data.value;
            this.searchFormListHandle();
        },
        queryFormList() {
            this.$store.dispatch("zhiji/queryFormList", {
                type: this.type,
                lang: this.lang,
                page: this.curPage,
                size: this.curPageLen,
                keyword: this.keyword,
                status: this.status
            });
        }
    },
    mounted() {
        this.$store.commit("zhiji/initFormQuerySet");
        this.$store.dispatch("zhiji/queryFormList", {
            page: this.curPage,
            size: this.curPageLen,
            classId: ""
        });
        this.searchFormListHandle = throttle(() => this.queryFormList(), 50, 200);
    }
};
</script>

<style lang="scss" scoped>
.form-manage-wrapper {
    height: 100%;
    display: flex;
    box-sizing: border-box;

    .form-table {
        font-size: 14px;
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: auto;

        .content-top {
            padding: 15px 16px 16px 24px;
            box-sizing: border-box;
        }
        .title{
            font-size:12px;
            >span{
                font-size: 14px;
            }
            em{
                color: #00c972;
            }
        }
    }

    .content-opeat {
        margin-top: 16px;
    }
}
</style>
